import {
  Component,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  NgZone,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { TurnstileService } from '../../services/turnstile.service';

declare const turnstile: any;

@Component({
  selector: 'app-turnstile',
  template: '<div #container></div>',
})
export class TurnstileComponent implements AfterViewInit, OnDestroy {
  @Input() siteKey!: string;
  @Output() tokenChange = new EventEmitter<string | null>();

  @ViewChild('container', { static: true }) container!: ElementRef<HTMLDivElement>;

  private widgetId: string | null = null;
  private resetSubscription: Subscription | null = null;

  constructor(
    private ngZone: NgZone,
    private turnstileService: TurnstileService,
  ) {}

  ngAfterViewInit(): void {
    this.renderWidget();
    this.resetSubscription = this.turnstileService.onResetRequested().subscribe(() => {
      this.ngZone.run(() => this.reset());
    });
  }

  ngOnDestroy(): void {
    this.resetSubscription?.unsubscribe();
    if (this.widgetId != null) {
      try {
        turnstile.remove(this.widgetId);
      } catch (_) {}
    }
  }

  reset(): void {
    if (this.widgetId != null) {
      try {
        turnstile.reset(this.widgetId);
      } catch (_) {}
      this.tokenChange.emit(null);
    }
  }

  private renderWidget(): void {
    if (typeof turnstile === 'undefined') {
      setTimeout(() => this.renderWidget(), 200);
      return;
    }

    this.widgetId = turnstile.render(this.container.nativeElement, {
      sitekey: this.siteKey,
      theme: 'light',
      callback: (token: string) => {
        this.ngZone.run(() => this.tokenChange.emit(token));
      },
      'expired-callback': () => {
        this.ngZone.run(() => this.tokenChange.emit(null));
      },
      'error-callback': () => {
        this.ngZone.run(() => this.tokenChange.emit(null));
      },
    });
  }
}
